import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/icon/scan.png';

const _withScopeId = n => (_pushScopeId("data-v-11d771bb"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "withdraw-container"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "font-size": "12px",
    "color": "red",
    "padding": "0 16px",
    "margin-top": "-5px"
  }
};
const _hoisted_3 = {
  class: "withdraw-title"
};
const _hoisted_4 = {
  class: "withdraw-input-area",
  style: {
    "padding": "0 16px"
  }
};
const _hoisted_5 = {
  key: 1,
  class: "withdraw-card"
};
const _hoisted_6 = {
  style: {
    "font-size": "12.5px"
  }
};
const _hoisted_7 = {
  class: "btn-area"
};
const _hoisted_8 = {
  class: "btn-area"
};
const _hoisted_9 = {
  class: "withdraw-title"
};
const _hoisted_10 = {
  class: "withdraw-input-area"
};
const _hoisted_11 = {
  style: {
    "font-size": "13px"
  }
};
const _hoisted_12 = {
  style: {
    "color": "#8e8f91",
    "margin-right": "8px"
  }
};
const _hoisted_13 = {
  class: "withdraw-card"
};
const _hoisted_14 = {
  class: "card-item",
  style: {
    "padding-bottom": "6px"
  }
};
const _hoisted_15 = {
  class: "item-label"
};
const _hoisted_16 = {
  key: 0,
  class: "item-value"
};
const _hoisted_17 = {
  key: 1,
  class: "item-value"
};
const _hoisted_18 = {
  key: 2,
  class: "item-value"
};
const _hoisted_19 = {
  key: 3,
  class: "item-value"
};
const _hoisted_20 = {
  key: 4,
  class: "item-value"
};
const _hoisted_21 = {
  class: "card-item"
};
const _hoisted_22 = {
  class: "item-label"
};
const _hoisted_23 = {
  class: "item-value"
};
const _hoisted_24 = {
  class: "card-item"
};
const _hoisted_25 = {
  class: "withdraw-card"
};
const _hoisted_26 = {
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_27 = {
  style: {
    "margin-bottom": "10px"
  }
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "padding-top": "130px"
  }
}, null, -1));

const _hoisted_29 = {
  class: "withdraw-footer"
};
const _hoisted_30 = {
  class: "footer-item"
};
const _hoisted_31 = {
  class: "label"
};
const _hoisted_32 = {
  class: "value"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  class: "title"
};
const _hoisted_35 = {
  class: "sub-title"
};
import { ref, watch, onMounted, onBeforeMount, computed } from 'vue';
import store from '@/store';
import router from '@/router';
import { useRoute } from 'vue-router';
import { Toast } from 'vant';
import 'vant/es/toast/style';
import BaseTradeHeader from '@/components/BaseTradeHeader.vue';
import CustomPopupList from '@/components/CustomPopupList.vue';
import ScanQrcode from '@/components/ScanQrcode.vue';
import TradePwd from '@/components/TradePwd.vue';
import { marketInfoWithdraw, withdraw, userInfo, getUserAsset, withdrawCheck, withdrawSend } from '@/apis';
import { useWindowSize } from '@vant/use';
import { fmtImageSrc } from '@/util'; // import BigNumber from 'bignumber.js'

import { useI18n } from "vue-i18n";
import { fmtNumber } from '@/util';
import GoogleCodeModal from '@/components/GoogleCodeModal.vue';
export default {
  __name: 'WithdrawView',

  setup(__props) {
    const {
      t
    } = useI18n();
    const netType = ref(0);
    const netList = ref(['USDT-ERC20', 'USDT-TRC20']);
    const netType1 = ref(0);
    const netList1 = ref(['USDC-ERC20']);
    const coinList = ref([]);
    const coin = ref({
      name: ''
    });
    const address = ref('');
    const coinShow = ref(false);
    const authStatus = ref(0);
    const {
      height
    } = useWindowSize();
    const oldHeight = height.value;
    const footerShow = ref(true);
    const balance = computed(() => {
      if (coinList.value.length > 0 && coin.value.name != null) {
        return spotList.value[coin.value.name];
      } else {
        return 0;
      }
    });
    const withdrawNum = ref();
    const loading = ref(false);
    const pwdShow = ref(false);
    const googleCodeShow = ref(false);
    const pendingWithdraw = ref(null);
    const scanShow = ref(false);
    onBeforeMount(() => {
      getAsset();
    });
    const spotList = ref({});

    const getAsset = () => {
      getUserAsset({
        platform: 0
      }).then(res => {
        if (res.code === 200 && res.data) {
          res.data.map(item => {
            spotList.value[item.marketName] = item.active;
          });
        }
      });
    };

    const route = useRoute();
    let type = 'USDT';

    if (route.query.type) {
      type = route.query.type;
    }

    const scanCode = code => {
      address.value = code;
      scanShow.value = false;
    };

    watch(withdrawNum, () => {
      var pattern = /^[0-9]+(\.[0-9]{0,6})?$/;

      if (withdrawNum.value != '' && !pattern.test(withdrawNum.value)) {
        withdrawNum.value = Math.floor(Number((withdrawNum.value + '').replace(/[a-zA-Z]+/g, "")) * 1000000) / 1000000;
      }
    });
    watch([height], () => {
      let show = true;

      if (oldHeight - height.value > 120) {
        show = false;
      }

      footerShow.value = show;
    });
    onMounted(async () => {
      if (store.state.token === '') {
        router.replace({
          name: 'login'
        });
        return;
      }

      const toast = Toast.loading({
        duration: 0
      });
      const authRes = await userInfo({});

      if (authRes.code === 200 && authRes.data) {
        authStatus.value = authRes.data.authState;
      }

      const res = await marketInfoWithdraw({});

      if (res.code === 200 && res.data) {
        coinList.value = res.data.map(item => {
          const data = {
            id: item.id,
            icon: item.icon,
            name: item.marketName,
            fee: item.withdrawFee,
            min: item.withdrawMin,
            trc: item.withdrawFeeTrc
          };

          if (item.marketName === type) {
            coin.value = data;
          }

          return data;
        });
      }

      toast.clear();
    });

    const coinChange = async index => {
      coinShow.value = false;
      const toast = Toast.loading({
        duration: 0
      });
      coin.value = coinList.value[index];
      toast.clear();
    };

    const checkWithdraw = async () => {
      if (address.value === '') {
        Toast({
          message: t('withdrawAddressInput'),
          position: 'bottom'
        });
        return;
      }

      if (!withdrawNum.value) {
        Toast({
          message: t('withdrawNumInput'),
          position: 'bottom'
        });
        return;
      }

      const minNum = netList.value.length > 0 ? netList.value[netType.value].min || 0 : coin.value ? coin.value.min || 0 : 0;

      if (minNum && Number(withdrawNum.value) < Number(minNum)) {
        Toast({
          message: t('withdrawNumLess'),
          position: 'bottom'
        });
        return;
      }

      const fee = netList.value.length > 0 ? netList.value[netType.value].fee : coin.value ? coin.value.fee : 0;

      if (fee && Number(withdrawNum.value) <= Number(fee)) {
        Toast({
          message: t('withdrawNumLess'),
          position: 'bottom'
        });
        return;
      }

      if (Number(withdrawNum.value) > balance.value) {
        Toast({
          message: t('balanceTip'),
          position: 'bottom'
        });
        return;
      }

      if (authStatus.value !== 2) {
        Toast({
          message: t('withdrawTip'),
          position: 'bottom'
        });
        return;
      }

      loading.value = false;
      let name = '';
      if (coin.value.name == 'USDT' || coin.value.name == 'USDC') name = netList.value[netType.value];else name = coin.value.name;
      const res = await withdrawCheck({
        coinType: name,
        address: address.value
      });

      if (Number(res.code) === 200) {
        pwdShow.value = true;
      } else {
        Toast({
          message: res.msg || t('withdrawFail'),
          position: 'bottom'
        });
      }
    };

    const showPwdInput = async () => {
      await checkWithdraw();
    };

    const submitWithdraw = async (pwd, code, gacode = '') => {
      loading.value = true;

      if (!gacode) {
        const authRes = await userInfo({});

        if (Number(authRes.code) !== 200 || !authRes.data) {
          loading.value = false;
          Toast({
            message: authRes.msg || t('withdrawFail'),
            position: 'bottom'
          });
          return;
        }

        if (authRes.data.gaSecret) {
          pendingWithdraw.value = {
            pwd,
            code
          };
          loading.value = false;
          pwdShow.value = false;
          googleCodeShow.value = true;
          return;
        }
      }

      let name = '';
      if (coin.value.name == 'USDT') name = netList.value[netType.value];else if (coin.value.name == 'USDC') name = netList1.value[netType1.value];else name = coin.value.name;
      const data = {
        coinType: name,
        amount: Number(withdrawNum.value),
        address: address.value,
        password: pwd,
        code
      };
      if (gacode) data.gacode = gacode;
      const res = await withdraw(data);
      loading.value = false;

      if (Number(res.code) === 200) {
        pendingWithdraw.value = null;
        googleCodeShow.value = false;
        router.push({
          name: 'withdrawRes',
          query: {
            id: res.data
          }
        });
        return;
      }

      Toast({
        message: res.msg || t('withdrawFail'),
        position: 'bottom'
      });
    };

    const commit = async (pwd, code) => {
      if (!code || code === '') {
        Toast({
          message: t('checkCodeInput'),
          position: 'bottom'
        });
        return;
      }

      await submitWithdraw(pwd, code);
    };

    const cancelGoogleCode = () => {
      if (!loading.value) {
        googleCodeShow.value = false;
        pendingWithdraw.value = null;
      }
    };

    const confirmGoogleCode = async gacode => {
      if (pendingWithdraw.value) {
        await submitWithdraw(pendingWithdraw.value.pwd, pendingWithdraw.value.code, gacode);
      }
    };

    const sendCheckCode = async () => {
      let name = '';
      if (coin.value.name == 'USDT') name = netList.value[netType.value];else if (coin.value.name == 'USDC') name = netList1.value[netType1.value];else name = coin.value.name;
      const res = await withdrawSend({
        coinType: name,
        amount: Number(withdrawNum.value)
      });

      if (res.code === 200) {
        Toast({
          message: t('sendSuccess'),
          position: 'bottom'
        });
        return;
      }

      Toast({
        message: res.msg !== '' ? res.msg : t('sendError'),
        position: 'bottom'
      });
    };

    const getBtnStyle = type => {
      const baseStyle = {
        '--van-button-default-height': '32px',
        '--van-button-normal-font-size': '12px',
        '--van-button-normal-padding': '0 10px',
        'fontWeight': '700',
        'width': '20'
      };

      if (netType.value === type) {
        return { ...baseStyle,
          '--van-button-default-border-color': '#F08504',
          '--van-button-default-color': '#F08504'
        };
      }

      return { ...baseStyle,
        '--van-button-default-background-color': '#F3F3F3',
        '--van-button-default-border-color': '#F3F3F3',
        '--van-button-default-color': 'black'
      };
    };

    const getBtnStyle1 = type => {
      const baseStyle = {
        '--van-button-default-height': '32px',
        '--van-button-normal-font-size': '12px',
        '--van-button-normal-padding': '0 10px',
        'fontWeight': '700',
        'width': '20'
      };

      if (netType1.value === type) {
        return { ...baseStyle,
          '--van-button-default-border-color': '#F08504',
          '--van-button-default-color': '#F08504'
        };
      }

      return { ...baseStyle,
        '--van-button-default-background-color': '#F3F3F3',
        '--van-button-default-border-color': '#F3F3F3',
        '--van-button-default-color': 'black'
      };
    };

    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");

      const _component_van_button = _resolveComponent("van-button");

      const _component_van_image = _resolveComponent("van-image");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", null, [_createVNode(BaseTradeHeader, {
        title: _unref(t)('withdraw'),
        text: coin.value ? coin.value?.name : _unref(t)('selectCurrency'),
        "history-router": "withdrawHistory",
        onCoinShow: _cache[0] || (_cache[0] = $event => coinShow.value = true)
      }, null, 8, ["title", "text"]), authStatus.value !== 2 ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('withdrawTip')), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('withdrawAddress')), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_input, {
        value: address.value,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => address.value = $event),
        bordered: false,
        class: "withdraw-input",
        placeholder: _unref(t)('withdrawAddressInput'),
        allowClear: ""
      }, {
        suffix: _withCtx(() => [_createElementVNode("img", {
          src: _imports_0,
          style: {
            "width": "25px"
          },
          onClick: _cache[1] || (_cache[1] = $event => scanShow.value = true)
        })]),
        _: 1
      }, 8, ["value", "placeholder"])]), netList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('withdrawNet')), 1), _withDirectives(_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(netList.value, (item, index) => {
        return _openBlock(), _createBlock(_component_van_button, {
          key: index,
          class: "btn-r",
          style: _normalizeStyle(getBtnStyle(index)),
          onClick: $event => netType.value = index
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
          _: 2
        }, 1032, ["style", "onClick"]);
      }), 128))], 512), [[_vShow, coin.value?.name == 'USDT']]), _withDirectives(_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(netList1.value, (item, index) => {
        return _openBlock(), _createBlock(_component_van_button, {
          key: index,
          class: "btn-r",
          style: _normalizeStyle(getBtnStyle1(index)),
          onClick: $event => netType1.value = index
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
          _: 2
        }, 1032, ["style", "onClick"]);
      }), 128))], 512), [[_vShow, coin.value?.name == 'USDC']])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('withdrawNum')), 1), _createElementVNode("div", _hoisted_10, [_createVNode(_component_a_input, {
        value: withdrawNum.value,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => withdrawNum.value = $event),
        class: "withdraw-input",
        bordered: false,
        placeholder: _unref(t)('withdrawNumInput'),
        allowClear: "",
        type: "number"
      }, {
        suffix: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(coin.value?.name), 1), _createElementVNode("span", {
          onClick: _cache[3] || (_cache[3] = $event => withdrawNum.value = _unref(balance))
        }, _toDisplayString(_unref(t)('all')), 1)])]),
        _: 1
      }, 8, ["value", "placeholder"])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('fee')), 1), coin.value?.name == 'USDT' && netType.value == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(fmtNumber)(coin.value.fee)) + " " + _toDisplayString(coin.value?.name), 1)) : coin.value?.name == 'USDT' && netType.value == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(fmtNumber)(coin.value.trc)) + " " + _toDisplayString(coin.value?.name), 1)) : coin.value?.name == 'USDC' && netType1.value == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(fmtNumber)(coin.value.fee)) + " " + _toDisplayString(coin.value?.name), 1)) : coin.value?.name == 'USDC' && netType1.value == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(fmtNumber)(coin.value.trc)) + " " + _toDisplayString(coin.value?.name), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(fmtNumber)(coin.value.fee)) + " " + _toDisplayString(coin.value?.name), 1))]), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)('withdrawMin')), 1), _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(fmtNumber)(coin.value.min)) + " " + _toDisplayString(coin.value?.name), 1)]), _createElementVNode("div", _hoisted_24, [_createTextVNode(_toDisplayString(_unref(t)('withdrawTip4')) + " ", 1), coin.value?.name == 'USDT' && netType.value == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(_unref(fmtNumber)(coin.value.fee)) + " " + _toDisplayString(coin.value?.name), 1)], 64)) : coin.value?.name == 'USDT' && netType.value == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode(_toDisplayString(_unref(fmtNumber)(coin.value.trc)) + " " + _toDisplayString(coin.value?.name), 1)], 64)) : coin.value?.name == 'USDC' && netType1.value == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createTextVNode(_toDisplayString(_unref(fmtNumber)(coin.value.fee)) + " " + _toDisplayString(coin.value?.name), 1)], 64)) : coin.value?.name == 'USDC' && netType1.value == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 3
      }, [_createTextVNode(_toDisplayString(_unref(fmtNumber)(coin.value.trc)) + " " + _toDisplayString(coin.value?.name), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 4
      }, [_createTextVNode(_toDisplayString(_unref(fmtNumber)(coin.value.fee)) + " " + _toDisplayString(coin.value?.name), 1)], 64)), _createTextVNode(" " + _toDisplayString(_unref(t)('withdrawTip5')) + " ", 1), coin.value?.name == 'USDT' && netType.value == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 5
      }, [_createTextVNode(_toDisplayString(_unref(fmtNumber)(coin.value.fee)) + " " + _toDisplayString(coin.value?.name), 1)], 64)) : coin.value?.name == 'USDT' && netType.value == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 6
      }, [_createTextVNode(_toDisplayString(_unref(fmtNumber)(coin.value.trc)) + " " + _toDisplayString(coin.value?.name), 1)], 64)) : coin.value?.name == 'USDC' && netType1.value == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 7
      }, [_createTextVNode(_toDisplayString(_unref(fmtNumber)(coin.value.fee)) + " " + _toDisplayString(coin.value?.name), 1)], 64)) : coin.value?.name == 'USDC' && netType1.value == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 8
      }, [_createTextVNode(_toDisplayString(_unref(fmtNumber)(coin.value.trc)) + " " + _toDisplayString(coin.value?.name), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 9
      }, [_createTextVNode(_toDisplayString(_unref(fmtNumber)(coin.value.fee)) + " " + _toDisplayString(coin.value?.name), 1)], 64)), _createTextVNode(" " + _toDisplayString(_unref(t)('withdrawTip6')), 1)])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('withdrawTip1')), 1), _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)('withdrawTip2')), 1), _createElementVNode("div", null, _toDisplayString(_unref(t)('withdrawTip3')), 1)]), _hoisted_28, _withDirectives(_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)('balanceUse')), 1), _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(balance)) + " " + _toDisplayString(coin.value?.name), 1)]), _createVNode(_component_van_button, {
        type: "primary",
        block: "",
        onClick: showPwdInput,
        style: {
          "--van-button-default-height": "42px",
          "margin-top": "10px",
          "background-color": "#F08504",
          "border-color": "#F08504"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('withdraw')), 1)]),
        _: 1
      })], 512), [[_vShow, footerShow.value]]), _createVNode(CustomPopupList, {
        "c-show": coinShow.value,
        title: _unref(t)('currencyType'),
        onHide: _cache[5] || (_cache[5] = () => {
          coinShow.value = false;
        }),
        position: 'center',
        height: 'auto',
        style: {
          "border-radius": "10px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coinList.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "coin-item",
            key: index,
            onClick: $event => coinChange(index)
          }, [_createVNode(_component_van_image, {
            src: _unref(fmtImageSrc)(item.icon),
            width: "25",
            height: "25",
            style: {
              "margin-right": "12px"
            },
            round: ""
          }, null, 8, ["src"]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_34, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_35, _toDisplayString(item.name), 1)])], 8, _hoisted_33);
        }), 128))]),
        _: 1
      }, 8, ["c-show", "title"]), _createVNode(TradePwd, {
        loading: loading.value,
        show: pwdShow.value,
        onHide: _cache[6] || (_cache[6] = $event => pwdShow.value = false),
        onTradeCommit: commit,
        onSendCode: sendCheckCode,
        "show-code": true,
        text: _unref(t)('withdraw')
      }, null, 8, ["loading", "show", "text"]), _createVNode(GoogleCodeModal, {
        show: googleCodeShow.value,
        loading: loading.value,
        onHide: cancelGoogleCode,
        onConfirm: confirmGoogleCode
      }, null, 8, ["show", "loading"])], 512), [[_vShow, !scanShow.value]]), scanShow.value ? (_openBlock(), _createBlock(ScanQrcode, {
        key: 0,
        onHide: _cache[7] || (_cache[7] = $event => scanShow.value = false),
        onCode: scanCode
      })) : _createCommentVNode("", true)]);
    };
  }

};